// src/locale/currency.ts
var getSafeCurrencySymbol = ({ currencyCode, locale }) => {
  try {
    const currencyIntl = new Intl.DisplayNames([locale], { type: "currency" });
    return currencyIntl.of(currencyCode) || currencyCode;
  } catch (error) {
    return currencyCode;
  }
};

export {
  getSafeCurrencySymbol
};
//# sourceMappingURL=chunk-JAXLPLOH.mjs.map